export default function initChangeHeader() {
  const header = document.querySelector("header");
  const submenuActive = document.querySelectorAll(".header__nav > .sub-menu");

  const scrollChange = 50;
  let scrollpos = window.scrollY


  window.addEventListener('scroll', function() { 
    scrollpos = window.scrollY;
    if (scrollpos >= scrollChange) { 
      header.classList.add("header--dark");

      for (var i = 0, len = submenuActive.length; i < len; i++) {
        this.classList.remove("sub-menu--active");
      }

    } else {
      header.classList.remove("header--dark")
    }
  });
}
